import {
  dealTypeFromJsonQuery,
  FDealType,
  getRangeValue,
  isCommercial,
  offerTypeFromJsonQuery,
  resetTerms,
} from '../../../../JsonQuery';
import { TTagsManager } from '../../types/tag';
import { createTagValue } from '../../utils/createTagValue';
import { fillLabelTemplate } from '../../utils/fillLabelTemplate';

const ID = 'site' as const;

export const landAreaTagManager: TTagsManager = {
  id: ID,
  extractTagsFromJsonQuery: ({ jsonQuery }) => {
    const dealType = dealTypeFromJsonQuery(jsonQuery);
    const offerType = offerTypeFromJsonQuery(jsonQuery);
    const landArea = getRangeValue('site')(jsonQuery);

    if (landArea === null || dealType !== FDealType.RentLongterm || isCommercial(offerType)) {
      return null;
    }

    const { gte, lte } = landArea;
    const from = gte ? `от ${gte}` : '';
    const to = lte ? `до ${lte}` : '';

    return [{ label: fillLabelTemplate(`Площадь участка %s сот.`, `${from} ${to}`).trim(), value: createTagValue(ID) }];
  },
  modifyJsonQueryByRemovingTag: ({ jsonQuery }) => resetTerms(['site'])(jsonQuery),
};
